import React, { CSSProperties, memo, useContext } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { LayoutSettings, MenuItem } from '@/types';
import UnAuthLayoutContext from '@/context/UnAuthLayoutContext';
import { ILayoutContext } from '@/context/LegacyLayoutContext';
import classNames from 'classnames';
import styles from './SideMenu.module.pcss';

interface Props extends Partial<LayoutSettings> {
  mode?: string;
  style?: CSSProperties;
  className?: string;
  layout?: string;
  menuItems: MenuItem[];
}

const BaseMenu = memo<Props>((props) => {
  const location = useLocation();
  const layoutContext = useContext<ILayoutContext>(UnAuthLayoutContext);

  const getMenuItemPath = (item: MenuItem) => {
    const pathName = item.params ? `${item.path}${item.params}` : item.path;
    return (
      <Link to={pathName} replace={pathName === location.pathname}>
        <span>{item.title}</span>
      </Link>
    );
  };

  const getNavMenuItems = () =>
    props.menuItems.map((item) => ({
      key: item.path,
      label: getMenuItemPath(item),
      icon: item.icon,
      className: styles.menuItem,
    }));

  return (
    <Menu
      className={classNames(styles.baseMenu, styles[layoutContext.layoutConfig?.title.name])}
      mode="inline"
      selectedKeys={[location.pathname]}
      items={getNavMenuItems()}
    />
  );
});

export default BaseMenu;
